import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import { selectCmsControlByIdByPage } from "../../../../redux/slices/cmsSettingsSlice";
import { selectAllP2pSettings } from "../../../../redux/slices/p2pSettingsSlice";
import { selectAllClassifications } from "../../../../redux/slices/classificationsSlice";
import { selectAllRegistration } from "../../../../redux/slices/registrationSlice";
import {
    selectTeamModalOpen,
    setAppShowRemainingForm,
    setAppTeamModalOpen,
} from "../../../../redux/slices/appSettingsSlice";
import TeamRoleCard from "./TeamRoleCard";

const ConnectedTeamRoleCard = ({ controlId, ...props }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const dispatch = useDispatch();
    const { values, handleChange } = useFormikContext();
    const { Team = "" } = values;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );
    const {
        options: {
            registrationRole: {
                teamRegistrationDescription,
                teamRegistrationLabel = "Join or Start a Team",
            },
        },
    } = control;

    const p2pSettings = useSelector(selectAllP2pSettings);
    const { enableIndividualRegistration, enableTeams } = p2pSettings;

    const teamModalOpen = useSelector(selectTeamModalOpen);

    const classifications = useSelector(selectAllClassifications);
    const registration = useSelector(selectAllRegistration);
    const {
        classification: { Classification = [] },
    } = registration;

    const classification =
        Object.keys(registration.classification).length > 0 &&
        typeof Classification[0] === "string"
            ? classifications.find(({ id }) => `${id}` === Classification[0])
            : {};

    const { registrantSpotsLeftOnAllTeams } = classification;

    const preventValueChange =
        !enableIndividualRegistration && enableTeams ? true : undefined;

    const title = teamRegistrationLabel;

    const description = teamRegistrationDescription;

    const displayOnlyIndividualRegistrationAvailable =
        enableIndividualRegistration &&
        typeof registrantSpotsLeftOnAllTeams === "number" &&
        registrantSpotsLeftOnAllTeams === 0;

    const disabled = displayOnlyIndividualRegistrationAvailable
        ? true
        : undefined;

    const handleTeamRoleClick = () => {
        if (!teamModalOpen && Team === "") {
            dispatch(setAppTeamModalOpen(true));
        }
    };

    const handleTeamRoleChange = preventValueChange
        ? (e) => {
              if (preventValueChange) {
                  e.preventDefault();
                  dispatch(setAppTeamModalOpen(true));
              }
          }
        : (e) => {
              handleChange(e);
              if (e.target.checked && Team !== "") {
                  dispatch(setAppShowRemainingForm(true));
              }
          };

    const teamRoleCardProps = {
        description,
        disabled,
        title,
        setAppTeamModalOpen,
        handleClick: handleTeamRoleClick,
        handleChange: handleTeamRoleChange,
        ...props,
    };

    return <TeamRoleCard {...teamRoleCardProps} />;
};

ConnectedTeamRoleCard.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedTeamRoleCard;
